import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import store from "@/store";
  import getUserData from "@/helpers/listing/getUserData";
  import { useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigureAgentIdModal',
  props: {
    isOpen: {
      type: Boolean,
      required: false,
    },
  },
  emits: ["close", "saveAgentId"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  const toast = useToast();
  const agentId = getUserData().agentId;
  const agentIdForm = ref(agentId);

  function close() {
    emits("close");
  }

  const submit = (value: string) => {
    if (/^[a-zA-Z]+$/.test(value)) {
      emits("saveAgentId", value);
    } else {
      toast.error("AgentID must not contain numbers or special characters");
    }
  };

const __returned__ = { emits, props, toast, agentId, agentIdForm, close, submit, ref, Modal, get store() { return store }, get getUserData() { return getUserData }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})